// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const {
  CapsuleButton,
  CircleButton,
  CollectionSubscribeCapsuleButton
} = require('client-v2/common/components/buttons')
const { registerComponentEventHandlers } = require('client-v2/common/components/utils')
const Icon = require('client-v2/common/containers/icons/component')
const WithTooltip = require('client-v2/common/containers/tooltips/component-smart')
// Container imports
const CollectionModelRecord = require('../collection/record')
const CollectionProfileNavLinks = require('../nav-links/component-smart')

const bem = BemEntity('CollectionProfileNav')

class CollectionProfileNav extends React.PureComponent {
  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    registerComponentEventHandlers(this)
  }

  renderEditButton() {
    if (!this.props.isSelfProfile) {
      return null
    }
    return tag(CapsuleButton, {
      className: classNames(
        bem.element('button'),
        bem.element('edit-button')
      ),
      title: 'Edit this Collection',
      onClick: this.onEditClick
    },
      'Edit'
    )
  }

  renderSubscribeButton() {
    if (this.props.isSelfProfile) {
      return null
    }
    return tag(WithTooltip, {
      placement: ['left', 'bottom-end'],
      tooltipKey: 'collection-profile-subscribe'
    },
      tag(CollectionSubscribeCapsuleButton, {
        className: classNames(
          bem.element('button'),
          bem.element('subscribe-button')
        ),
        checked: this.props.collection.isFollowing,
        onClick: this.onFollowClick
      })
    )
  }

  renderShareButton() {
    const { visibility } = this.props.collection
    if (visibility !== CollectionModelRecord.VISIBILITY_PUBLIC) {
      return null
    }
    return (
      tag(CircleButton, {
        className: classNames(
          bem.element('button'),
          bem.element('share-button')
        ),
        title: 'Share this Collection',
        onClick: this.onShareClick
      },
        tag(Icon, { id: 'share-network' })
      )
    )
  }

  render() {
    return tag('div', {
      className: classNames(
        this.props.className,
        bem.block()
      )
    },
      tag(CollectionProfileNavLinks, {
        className: bem.element('links')
      }),
      tag('div', {
        className: bem.element('buttons')
      },
        this.renderShareButton(),
        this.renderEditButton(),
        this.renderSubscribeButton()
      )
    )
  }
}

// Callbacks
CollectionProfileNav.eventHandlerKeys = [
  'onEditClick',
  'onFollowClick',
  'onShareClick'
]

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  CollectionProfileNav.propTypes = {
    // Values
    className: PropTypes.string,
    collection: PropTypes.shape(CollectionModelRecord.propTypes).isRequired,
    isSelfProfile: PropTypes.bool
  }
  // Callbacks
  CollectionProfileNav.eventHandlerKeys.forEach(key => {
    CollectionProfileNav.propTypes[key] = PropTypes.func
  })
}

module.exports = CollectionProfileNav
